var q,
WRKSP = {

  settings: {
    container: null,
    wrapper: null,
    workshopNavTriggers: null,
    steps: null,
    currentStep: 0,
    selectedTypeName: null,
    selectedTypePrice: null,
    selectedDate: null,
    selectedTime: null,
    tl: gsap.timeline(),
    stepTwoInit: false,
    currentAvailabilities: null,
    working: false,
  },

  init: function() {
    q = this.settings;

    const workshopContainer = document.querySelector('#book-an-appointment-container');

    if (workshopContainer) {
      q.container = workshopContainer;

      this.buildHTML();

      const workshopOg = document.querySelector('#book-an-appointment');

      const workshopLastScreenFields = document.querySelector('.workshop__step-wrap[data-step="3"] .workshop__step-form-fields');

      workshopLastScreenFields.prepend(workshopOg);
      
    }
  },

  buildHTML: () => {
    const wrapper = document.createElement("div");
    wrapper.classList.add('workshop');
    wrapper.classList.add('workshop--loading');
    const template = document.querySelector(".workshop-template");

    wrapper.innerHTML = template.innerHTML;
    q.container.prepend(wrapper);
    q.wrapper = wrapper;

    setTimeout(() => {
      wrapper.classList.remove('workshop--loading');
    }, 4500);

    const workshopNavTriggers = document.querySelectorAll('[data-workshop-nav-trigger]');

    if (workshopNavTriggers) {
      q.workshopNavTriggers = workshopNavTriggers;
      for (let workshopNavTrigger of workshopNavTriggers) {
        workshopNavTrigger.addEventListener('click', e => {
          const toStep = parseInt(workshopNavTrigger.dataset.workshopNavTrigger);
          if ((toStep == 1 && q.selectedTypeName) || (toStep == 2 && q.selectedTime) || toStep == 0) {
            WRKSP.changeStep(toStep, false);
          }
        });
      }
    }

    const workshopSteps = document.querySelectorAll('.workshop__step-wrap');

    if (workshopSteps) {
      q.steps = workshopSteps;

      WRKSP.changeStep(0, false);
    }

    const workshopAccordions = document.querySelectorAll('[workshop-accordion-trigger]');

    if (workshopAccordions) {
      for (let workshopAccordion of workshopAccordions) {
        workshopAccordion.addEventListener('click', e => {
          const expanded = workshopAccordion.getAttribute('aria-expanded') === 'true';
          const target = document.querySelector(`#${workshopAccordion.getAttribute('aria-controls')}`);

          workshopAccordion.setAttribute('aria-expanded', !expanded);
          target.setAttribute('aria-expanded', !expanded);

          if (!expanded) {
            gsap.to(target, { duration: 0.25, height: 'auto', autoAlpha: 1 });
          } else {
            gsap.to(target, { duration: 0.25, height: 0, autoAlpha: 0 });
          }
        });
      }
    }

    // Step 1
    const workshopSelectTypes = document.querySelectorAll('[workshop-select-type]');

    if (workshopSelectTypes) {
      for (let workshopSelectType of workshopSelectTypes) {
        workshopSelectType.addEventListener('click', e => {
          q.selectedTypeName = workshopSelectType.dataset.value;
          q.selectedTypePrice = workshopSelectType.dataset.price;
          WRKSP.changeStep(1);

          const formFieldTypeofmaintenance = document.querySelector('#customFieldTypeofmaintenance');

          if (formFieldTypeofmaintenance) {
            formFieldTypeofmaintenance.value = workshopSelectType.dataset.value;
            formFieldTypeofmaintenance.dispatchEvent(new Event('change', { 'bubbles': true }));
          }
        });
      }
    }

    // Step 2
    const dateTimeSubmitButton = document.querySelector('[workshop-date-submit]');

    if (dateTimeSubmitButton) {
      dateTimeSubmitButton.addEventListener('click', e => {
        if (q.selectedTime) {
          WRKSP.changeStep(2);
        }
      });
    }

    // Step 3
    const workshopForm = document.querySelector('[workshop-step-form]');

    if (workshopForm) {
      // const workshopFormFields = workshopForm.querySelectorAll('input, textarea');

      // if (workshopFormFields) {
      //   for (let workshopFormField of workshopFormFields) {
      //     workshopFormField.addEventListener('keyup', e => {
      //       const correspondingFormField = document.querySelector(`#book-an-appointment #${e.target.id}`);
      //       correspondingFormField.value = e.target.value;
      //       // correspondingFormField.setAttribute('value', e.target.value);
      //       //correspondingFormField.focus();
      //       //correspondingFormField.dispatchEvent(new Event('keydown', { 'bubbles': true }));
      //       correspondingFormField.dispatchEvent(new KeyboardEvent('keydown', { key: 'a' }));
      //     });
      //   }
      // }

      const realWrapper = document.querySelector('#book-an-appointment');
      const realForm = document.querySelector('#appointmentForm');
      const submit = realForm.querySelector('input[type="submit"]');
      const fakeSubmitButton = document.querySelector('.workshop__step-form-submit');

      const workshopModal = document.querySelector('[workshop-modal]');

      const config = { attributes: true, childList: true, subtree: true };
      
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.target.classList.contains('has-error')) {
            fakeSubmitButton.disabled = false;
          } else if (mutation.target.id == 'ab-confirmation-message-box' && !mutation.target.classList.contains('ng-hide')) {
            WRKSP.openMessage(workshopModal);
          }

          //const workshopModalWrap = workshopModal.querySelector('[workshop-modal-wrap]');
          //workshopModalWrap.classList.remove('drawer-loader--loading');
        }
      };
      
      const observer = new MutationObserver(callback);

      observer.observe(realWrapper, config);
      
      workshopForm.addEventListener('submit', e => {
        e.preventDefault();
        submit.click();
        fakeSubmitButton.disabled = true;
      });
    }
  },

  openMessage: (workshopModal) => {
    workshopModal.setAttribute('aria-expanded', true);
  },

  // closeMessage: () => {
  //   const workshopModal = document.querySelector('[workshop-modal]');
  //   workshopModal.setAttribute('aria-expanded', false);
  // },

  changeStep: (step) => {

    q.steps[q.currentStep].style.display = 'none';
    q.steps[step].style.display = 'block';
    
    q.currentStep = step;

    const activeNavWorkshopNavTrigger = document.querySelector(`[data-workshop-nav-trigger="${step}"]`);
    if (activeNavWorkshopNavTrigger) {
      for (let workshopNavTrigger of q.workshopNavTriggers) {
        workshopNavTrigger.classList.remove('workshop__actions-link--active');
      }
      
      activeNavWorkshopNavTrigger.classList.add('workshop__actions-link--active');
    }

    // Step 2 init
    if (!q.stepTwoInit && step == 1) {
      q.stepTwoInit = true;

      const workshopDateInput = document.querySelector('[workshop-date-input]');

      // Get next available date
      const dateTimeNextAvailableBtn = document.querySelector('[workshop-date-next-available]');
  
      if (dateTimeNextAvailableBtn) {
        const dates = document.querySelectorAll('#calendar-table th .ng-binding');
        const days = document.querySelectorAll('#calendar-table tbody td');
  
        if (days) {
          for (let [i, day] of days.entries()) {
            const times = day.querySelectorAll('div:nth-child(odd)');
            let hasAvailableDays = false;
            for (let time of times) {
              if (time.classList.contains('available')) {
                hasAvailableDays = true;
              }
            }
            
            if (hasAvailableDays) {
              q.nextAvailableDate = dates[i].innerText;
              break;
            }
          }
        }

        dateTimeNextAvailableBtn.addEventListener('click', e => {
          //q.wrapper.classList.add('workshop--loading');

          q.selectedDate = q.nextAvailableDate;
          WRKSP.findSelectedDateInApp(WRKSP.toDateFormat(q.nextAvailableDate));
          workshopDateInput.value = WRKSP.toDateFormat(q.nextAvailableDate);
        });
      }

      // Fill out dates
      const workshopDateTimes = document.querySelector('[workshop-date-times]');
      const calendarTimes = document.querySelectorAll('shopify-calendar .baa-row:last-child > div:first-child tbody td div');

      if (calendarTimes) {
        for (let [i, calendarTime] of calendarTimes.entries()) {
          if (calendarTime.innerText != '') {
            const time = document.createElement("button");
            time.type = 'button';
            time.classList.add('button');
            time.classList.add('workshop__date-time');
            time.dataset.index = i;
            time.dataset.time = calendarTime.innerText;
            time.innerText = 'Booked';
            time.setAttribute('workshop-date-time', '');
            workshopDateTimes.append(time);

            time.addEventListener('click', e => {
              // Remove any existing first
              const removeDateTimeOnCalendar = document.querySelector('[data-ng-click="removeAppointment()"]');
              if (removeDateTimeOnCalendar) {
                removeDateTimeOnCalendar.click();
              }
              const dateTimeOnCalendar = q.currentAvailabilities[time.dataset.index];
              dateTimeOnCalendar.click();

              const activeBtn = document.querySelector('.workshop__date-time--active');
              if (activeBtn) {
                activeBtn.classList.remove('workshop__date-time--active');
              }

              q.selectedTime = time.innerText;
              time.classList.add('workshop__date-time--active');
              document.querySelector('[workshop-date-submit]').disabled = false;
            });
          }
        }
      }
  
      if (workshopDateInput) {
        let options = {
          timeZone: 'Australia/Melbourne',
          year: 'numeric',
        };
        let formatter = new Intl.DateTimeFormat("en-AU", options);
        const year = formatter.format(new Date());
  
        options = {
          timeZone: 'Australia/Melbourne',
          month: 'numeric',
        };
        formatter = new Intl.DateTimeFormat("en-AU", options);
        const month = formatter.format(new Date());
  
        options = {
          timeZone: 'Australia/Melbourne',
          day: 'numeric',
        };
        formatter = new Intl.DateTimeFormat("en-AU", options);
        const day = formatter.format(new Date());
  
        workshopDateInput.value = q.selectedDate;
  
        q.selectedDate = `${year}-${month.padStart(2, 0)}-${day.padStart(2, 0)}`;
        workshopDateInput.value = q.selectedDate;
        WRKSP.findSelectedDateInApp(q.selectedDate);

        let timer;
        workshopDateInput.addEventListener('change', e => {
          clearTimeout(timer);

          timer = setTimeout(() => {
            q.selectedDate = e.target.value;
            WRKSP.findSelectedDateInApp(q.selectedDate);
          }, 500);
        });
      }
    }

    // Step 3
    if (step == 2) {
      const workshopFormTypeNames = document.querySelectorAll('[workshop-step-form-type-name]');
      const workshopFormTypePrices = document.querySelectorAll('[workshop-step-form-type-price]');
      const workshopFormTypeDates = document.querySelectorAll('[workshop-step-form-type-date]');

      if (workshopFormTypeNames) {
        for (let workshopFormTypeName of workshopFormTypeNames) {
          workshopFormTypeName.innerText = q.selectedTypeName;
        }
        for (let workshopFormTypePrice of workshopFormTypePrices) {
          workshopFormTypePrice.innerText = q.selectedTypePrice;
        }
        for (let workshopFormTypeDate of workshopFormTypeDates) {
          workshopFormTypeDate.innerText = q.selectedDate;
        }
      }
    }
  },

  toDateFormat: (str) => {
    var date = new Date(str);
    var year = date.toLocaleString("default", { year: "numeric" });
    var month = date.toLocaleString("default", { month: "2-digit" });
    var day = date.toLocaleString("default", { day: "2-digit" });

    return year + "-" + month + "-" + day;
  },

  findSelectedDateInApp: (selectedDateTimestamp) => {
    selectedDateTimestamp = new Date(selectedDateTimestamp).getTime();

    const table = document.querySelector('#calendar-table');
    if (table) {
      let found = false;
      let currentDates = table.querySelectorAll('th .ng-binding');

      for (let [i, currentDate] of currentDates.entries()) {
        const dateString = WRKSP.toDateFormat(currentDate.innerText);
        const currentDateTimestamp = new Date(dateString).getTime();

        if (currentDateTimestamp == selectedDateTimestamp) {
          found = true;

          q.wrapper.classList.add('workshop--loading');

          setTimeout(() => {
            WRKSP.fillOutAvailabilities(i);
            q.wrapper.classList.remove('workshop--loading');
          }, 1200);
        }
      }

      while (!found) {
        currentDates = table.querySelectorAll('th .ng-binding');

        let firstTimestamp = WRKSP.toDateFormat(currentDates[0].innerText);
        firstTimestamp = new Date(firstTimestamp).getTime();
        let lastTimestamp = WRKSP.toDateFormat(currentDates[currentDates.length - 1].innerText);
        lastTimestamp = new Date(lastTimestamp).getTime();

        if (selectedDateTimestamp < firstTimestamp) {
          // Go back a week
          const backBtn = document.querySelector('week-calendar-navigation .baa-btn:nth-child(3)');
          backBtn.click();
        } else if (selectedDateTimestamp > lastTimestamp) {
          // Go forward a week
          const forwardBtn = document.querySelector('week-calendar-navigation .baa-btn:nth-child(4)');
          forwardBtn.click();
        }

        for (let [i, currentDate] of currentDates.entries()) {
          const dateString = WRKSP.toDateFormat(currentDate.innerText);
          const currentDateTimestamp = new Date(dateString).getTime();

          if (currentDateTimestamp == selectedDateTimestamp) {
            found = true;

            q.wrapper.classList.add('workshop--loading');

            setTimeout(() => {
              WRKSP.fillOutAvailabilities(i);
              q.wrapper.classList.remove('workshop--loading');
            }, 1200);
          }
        }
      }
    }
  },

  fillOutAvailabilities: (i) => {
    const days = document.querySelectorAll('#calendar-table tbody td');

    if (days) {
      const availabilties = days[i];
      const times = availabilties.querySelectorAll('div');
      q.currentAvailabilities = times;
      console.log(times)

      // Update select buttons
      const workshopDateTimeButtons = document.querySelectorAll('[workshop-date-time]');

      for (let [i, time] of times.entries()) {
        const workshopDateTimeButton = document.querySelector(`.workshop__date-time[data-index="${i}"]`);
        if (workshopDateTimeButton) {
          if (time.classList.contains('not-available')) {
            // Disable button
            workshopDateTimeButton.disabled = true;
            workshopDateTimeButton.innerText = 'Booked';
            workshopDateTimeButton.classList.remove('button--aqua');
            workshopDateTimeButton.classList.add('button--grey');
          } else {
            // Enable button
            workshopDateTimeButton.disabled = false;
            workshopDateTimeButton.innerText = 'Available';
            workshopDateTimeButton.classList.remove('button--grey');
            workshopDateTimeButton.classList.add('button--aqua');
          }
        }
      }
    }
  }
};

(function() {
  WRKSP.init();
})();